import { render, staticRenderFns } from "./TransferInformations.vue?vue&type=template&id=6249bc20&scoped=true"
import script from "./TransferInformations.vue?vue&type=script&lang=js"
export * from "./TransferInformations.vue?vue&type=script&lang=js"
import style0 from "./TransferInformations.vue?vue&type=style&index=0&id=6249bc20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6249bc20",
  null
  
)

export default component.exports